
import React, { useState } from "react";
import "./Home.css";
import { Link } from "react-router-dom";
import { FaBrain, FaUsers,FaArrowRight, FaLeaf, FaQuoteLeft, FaFacebook, FaTwitter, FaLinkedin, FaInstagram ,FaTimes } from "react-icons/fa";

const Home = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [popupContent, setPopupContent] = useState({ title: "", description: "" });

  const togglePopup = (title, description) => {
    setPopupContent({ title, description });
    setShowPopup(!showPopup);
  };

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero-section">
  <div className="hero-overlay"></div> 
  <video autoPlay muted loop playsInline className="hero-video">
    <source src="https://res.cloudinary.com/dy8shu8ss/video/upload/v1739270491/video_1739259384884_v0n2jt.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
  <div className="hero-content">
    <h1>Innovating Today. Transforming Tomorrow.</h1>
    <p>Shaping the future with intelligent solutions.</p>
    
  </div>
</section>


      {/* Mission Section */}
      <div className="mission-section">
        <h2 className="mission-heading">Our Mission</h2>
        <p className="mission-description">
    At Vero Disruptors, our mission is to drive innovation, empower individuals, 
    and create a sustainable future through cutting-edge technology. 
    We believe in harnessing the power of AI, data intelligence, and 
    automation to build solutions that positively impact businesses and communities. 
    Our commitment is extends beyond technology—we aim to foster talent, 
    embrace sustainability, and support a thriving digital ecosystem.
  </p>
        <div className="mission-cards">
          {/* Innovation Card */}
          <div
            className="mission-card innovation-card"
            style={{
              backgroundImage: `url('https://res.cloudinary.com/dy8shu8ss/image/upload/v1739716881/pexels-prathsnap-4105227_sbe1k3.jpg')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
            onClick={() => togglePopup("Innovation ", "At Vero Disruptors, innovation is at the core of everything we do. We believe technology can transform lives, and we are committed to developing groundbreaking solutions that solve real-world problems. From AI-driven applications to intelligent automation tools, we continuously explore new possibilities to drive efficiency, productivity, and positive change. Our goal is to push the boundaries of technology and create solutions that make a lasting impact.")}
          >
            <h3>Innovation</h3>
          </div>

          {/* Data Intelligence Card */}
          <div
            className="mission-card sustainability-card"
            style={{
              backgroundImage: `url('https://res.cloudinary.com/dy8shu8ss/image/upload/v1739723916/Screenshot_2025-02-16_215550_dfgeg2.png')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
            onClick={() => togglePopup("Data Intelligence", "Data is the foundation of the modern world, and at Vero Disruptors, we specialize in harnessing its power. We build data-driven solutions that enhance decision-making, automate processes, and provide actionable insights. Whether it's data science, machine learning, or AI, we help organizations unlock the full potential of their data. Our reusable data solutions streamline operations and drive efficiency across multiple industries.")}
          >
            <h3>Data Intelligence</h3>
          </div>

          {/* Sustainability Card */}
          <div
            className="mission-card sustainability-card"
            style={{
              backgroundImage: `url('https://res.cloudinary.com/dy8shu8ss/image/upload/v1739930589/pexels-asphotograpy-1002703_pabgvw.jpg')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
            onClick={() => togglePopup("Sustainability", "We are committed to preserving nature and ensuring a sustainable future. Industrial advancements have accelerated the depletion of natural resources, and it is our responsibility to act. At Vero Disruptors, we actively work towards eco-friendly innovations that reduce waste, conserve resources, and promote sustainability. We collaborate with organizations and individuals to develop solutions that balance technological progress with environmental responsibility.")}
          >
            <h3>Sustainability</h3>
          </div>

          {/* Community Card */}
          <div
            className="mission-card community-card"
            style={{
              backgroundImage: `url('https://res.cloudinary.com/dy8shu8ss/image/upload/v1739930606/pexels-fauxels-3184418_rd55hu.jpg')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
            onClick={() => togglePopup("Community", "People are at the heart of everything we do. At Vero Disruptors, we believe in empowering individuals and fostering a culture of growth and learning. Our initiatives support talent development, helping professionals enhance their skills in data engineering, AI, and emerging technologies. We also engage with communities, offering mentorship and opportunities that help bridge the gap between talent and industry needs.")}
          >
            <h3>Community</h3>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="features-section">
        <h2>What We Offer</h2>
        <div className="features-grid">
          <div className="feature-card">
            <FaBrain className="feature-icon" />
            <h3>AI & Data Science</h3>
            <p>We build cutting-edge AI and data science solutions to solve complex problems.</p>
          </div>
          <div className="feature-card">
            <FaUsers className="feature-icon" />
            <h3>Talent Development</h3>
            <p>We focus on developing data talent and helping organizations find the right people.</p>
          </div>
          
            <Link to="/nature-mission" className="feature-card nature-mission-card" title="Click to explore our Nature Mission">
  <FaLeaf className="feature-icon" />
  <h3>Nature Mission</h3>
  <p>We are committed to protecting the environment and promoting sustainability.</p>
  <div className="learn-more">  {/* THIS IS MISSING IN CSS */}
    <span>Learn More</span>
    <FaArrowRight className="arrow-icon" />
  </div>
</Link>
          
        </div>
      </div>

      {/* Testimonials Section */}
      <div className="testimonials-section">
        <h2>What People Say About Us</h2>
        <div className="testimonials-grid">
          <div className="testimonial-card">
            <FaQuoteLeft className="quote-icon" />
            <p>"Vero Disruptors has transformed the way we approach data science. Their solutions are innovative and impactful."</p>
          </div>
          <div className="testimonial-card">
            <FaQuoteLeft className="quote-icon" />
            <p>"The team at Vero Disruptors is highly skilled and professional. They delivered beyond our expectations."</p>
          </div>
        </div>
      </div>

      {/* Call-to-Action Section */}
<div className="cta-section">
  <div className="cta-content">
    <h2>Ready to Join Us?</h2>
    <p>Explore our open positions and become a part of our innovative team.</p>
    <button onClick={() => (window.location.href = "/careers")}>View Jobs</button>
  </div>
</div>
      {/* Footer */}
      
<footer className="footer">
  <div className="footer-content">
    <div className="footer-section">
      <h3>About Us</h3>
      <p>Vero Disruptors is a leading innovator in data-driven solutions, providing cutting-edge services to help businesses grow and succeed.</p>
    </div>
    <div className="footer-section">
      <h3>Quick Links</h3>
      <ul>
        <li><a href="/">Home</a></li>
        <li><a href="/products">Products</a></li>
        <li><a href="/services">Services</a></li>
        <li><a href="/careers">Careers</a></li>
        <li><a href="/contactus">Contact Us</a></li>
      </ul>
    </div>
    <div className="footer-section">
      <h3>Follow Us</h3>
      <div className="social-links">
        <a href="https://www.facebook.com/share/1AF81Af26p/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
          <FaFacebook />
        </a>
        
        <a
      href="https://www.linkedin.com/company/vero-disruptors-pvt-ltd/?originalSubdomain=in"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="LinkedIn"
      className="social-link"
      style={{ position: 'relative', zIndex: 10 }}  
    >
      <FaLinkedin />
    </a>


        
      </div>
      
    </div>
    
  </div>
  <div className="footer-legal-links">
  
  <a href="/contactus">Contact Us</a>
  <a href="/terms">Term Of Use</a>
  <a href="/privacy">Privacy Statement</a>
  <a href="/refund">            Refund Policy
</a>
  <a href="/about">About Us</a>

</div>

  <div className="contactus-footer">
    <p>Copyright © Vero Disruptors {new Date().getFullYear()}. All rights reserved.</p>
  </div>

  
</footer>

      {/* Pop-up Modal */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <h3>{popupContent.title}</h3>
            <p>{popupContent.description}</p>
            <FaTimes className="close-icon" onClick={() => setShowPopup(false)} />
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;